import { memo } from 'react';

import { ChronologicalScheduleExpectation } from '@/types/scheduleExpectation';
import { TimelineItem } from '@/ui';
import { formatShortDate } from '@/utils/dates';
import formatSequenceTypeKey from '@/utils/formatSequenceTypeKey';

import ScheduleExpectationItemDetail from './ScheduleExpectationItemDetail';
import ScheduleExpectationSequenceItemDetail from './ScheduleExpectationSequenceItemDetail';

interface Props {
  item: ChronologicalScheduleExpectation;
  isActive: boolean;
  activeExpectationId?: string | null;
  phaseId: string;
  /** @internal injected by Timeline */
  _index?: number;
}

const ScheduleExpectationItemAccordion = ({
  item,
  isActive,
  activeExpectationId,
  phaseId,
  _index = 0
}: Props) => {
  const { sequence, object_type, start_at, end_at } = item;
  const isSequence = object_type === 'CustomScheduleExpectationSequence' && !!sequence;
  const isCustom = object_type === 'CustomScheduleExpectation';

  const title = isSequence
    ? formatSequenceTypeKey(sequence.type_key)
    : isCustom
      ? 'Custom Expectation'
      : 'Default Expectation';

  const color: 'primary' | 'secondary' | 'warning' = isSequence
    ? 'secondary'
    : isCustom
      ? 'warning'
      : 'primary';

  const date = start_at ? formatShortDate(start_at) : undefined;

  return (
    <TimelineItem
      title={title}
      date={date}
      color={color}
      defaultOpen={isActive}
      autoScroll={isActive}
      _index={_index}>
      {end_at && (
        <div className="mb-2 text-xs text-uniform-gray-500">Ends: {formatShortDate(end_at)}</div>
      )}
      {isSequence ? (
        <ScheduleExpectationSequenceItemDetail
          item={item}
          activeExpectationId={activeExpectationId}
          phaseId={phaseId}
        />
      ) : (
        <ScheduleExpectationItemDetail
          item={item}
          activeExpectationId={activeExpectationId}
          phaseId={phaseId}
        />
      )}
    </TimelineItem>
  );
};

export default memo(ScheduleExpectationItemAccordion);
